import React, { useState } from 'react';
import './App.css';
import Login from './Login';
import Dashboard from './Dashboard';
import Empleados from './Empleados';
import Reloj from './Reloj';
import Liquidacion from './Liquidacion';
import Auditoria from './Auditoria';

function App() {
  // Memoria temporal del formulario
  const [nombre, setNombre] = useState('');
  const [correo, setCorreo] = useState('');
  const [mensaje, setMensaje] = useState('');

  // Formulario exclusivo de Cargadores para Autos Eléctricos
  const [nombreEV, setNombreEV] = useState('');
  const [correoEV, setCorreoEV] = useState('');
  const [telefonoEV, setTelefonoEV] = useState('');
  const [mensajeEV, setMensajeEV] = useState('');

  // --- CONTROLADOR DE TRÁFICO ---
  const rutaActual = window.location.pathname;
  if (rutaActual === '/admin') {
    return <Login />;
  }
  if (rutaActual === '/dashboard') {
    return <Dashboard />;
  }
  if (rutaActual === '/empleados') {
  return <Empleados />;
  }
  if (rutaActual === '/reloj') {
  return <Reloj />;
  }
  if (rutaActual === '/liquidacion') {
  return <Liquidacion />;
  }
  if (rutaActual === '/auditoria') {
  return <Auditoria />;
  }

  // ------------------------------

  // Función para enviar a la base de datos
  const enviarFormulario = async (e) => {
    e.preventDefault();
    try {
      const respuesta = await fetch('/api/contacto', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombre, correo, mensaje }),
      });

      if (respuesta.ok) {
        alert('¡Registro exitoso! Sus datos han sido recibidos por el equipo de ASPE.');
        setNombre(''); setCorreo(''); setMensaje('');
      } else {
        alert('Hubo un problema al procesar su solicitud. Intente nuevamente.');
      }
    } catch (error) {
      console.error('Error de conexión:', error);
      alert('Error de conexión con el servidor de ASPE.');
    }
  };

  // Envio del formulario exclusivo de Cargadores EV (misma API, origen distinto)
  const enviarFormularioEV = async (e) => {
    e.preventDefault();
    try {
      const respuesta = await fetch('/api/contacto', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre: nombreEV,
          correo: correoEV,
          mensaje: `Teléfono: ${telefonoEV || 'no indicado'}\n\n${mensajeEV || 'Sin detalles adicionales.'}`,
          origen: 'cargador_ev',
        }),
      });

      if (respuesta.ok) {
        alert('¡Gracias! Recibimos su solicitud de presupuesto para cargador de auto eléctrico. Nos pondremos en contacto a la brevedad.');
        setNombreEV(''); setCorreoEV(''); setTelefonoEV(''); setMensajeEV('');
      } else {
        alert('Hubo un problema al procesar su solicitud. Intente nuevamente.');
      }
    } catch (error) {
      console.error('Error de conexión:', error);
      alert('Error de conexión con el servidor de ASPE.');
    }
  };

  return (
    <div className="App">
      {/* --- ENCABEZADO --- */}
      <header className="header-elegante">
        <div className="header-container">
          <a href="/"><img src="/logo.png" alt="ASPE Logo" className="logo-aspe" /></a>
          <nav>
            <ul className="nav-links">
              <li><a href="#inicio">Inicio</a></li>
              <li><a href="#servicios">Servicios</a></li>
              <li><a href="#cargadores-ev">Cargadores EV</a></li>
              <li><a href="#registro">Contacto</a></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* --- CONTENIDO PRINCIPAL --- */}
      <main>
        {/* FRANJA PROMOCIONAL - CARGADORES EV */}
        <div className="promo-ev-bar">
          <span className="promo-ev-badge">NUEVO</span>
          <span className="promo-ev-texto">⚡ Instalamos cargadores para autos eléctricos — Presupuesto sin cargo</span>
          <a href="#cargadores-ev" className="promo-ev-btn">Cotizar ahora</a>
        </div>

        {/* SECCIÓN INICIO (HERO) */}
        <section id="inicio" className="hero-section">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Energía Inteligente & Excelencia Técnica</h1>
            <p>
              En <strong>Acosta Silva Proeléctrica (ASPE)</strong> desarrollamos e implementamos soluciones de ingeniería eléctrica de vanguardia en <strong>Maldonado</strong> y todo Uruguay. Optimizamos recursos, garantizamos seguridad y potenciamos el futuro de la industria.
            </p>
            <a href="#servicios" className="btn-primario">Descubrir Servicios</a>
          </div>
        </section>

        {/* SECCIÓN CARGADORES PARA AUTOS ELÉCTRICOS */}
        <section id="cargadores-ev" className="cargadores-ev-section">
          <div className="cargadores-ev-container">
            <div className="cargadores-ev-info">
              <span className="cargadores-ev-eyebrow">MOVILIDAD ELÉCTRICA</span>
              <h2>Cargadores para Autos Eléctricos</h2>
              <p>
                Instalamos cargadores domiciliarios y comerciales para vehículos eléctricos en Maldonado, Punta del Este y todo Uruguay, con la garantía de una empresa eléctrica habilitada ante UTE. Presupuesto sin cargo y sin compromiso.
              </p>
              <ul className="cargadores-ev-beneficios">
                <li>✓ Instalación segura y certificada</li>
                <li>✓ Asesoramiento sobre el cargador ideal para su vehículo</li>
                <li>✓ Habilitación ante UTE incluida</li>
                <li>✓ Presupuesto sin cargo</li>
              </ul>
            </div>

            <form className="formulario-ev" onSubmit={enviarFormularioEV}>
              <h3>Solicitar Presupuesto</h3>
              <div className="input-group">
                <input type="text" placeholder="Nombre completo" required value={nombreEV} onChange={(e) => setNombreEV(e.target.value)} />
              </div>
              <div className="input-group">
                <input type="email" placeholder="Correo electrónico" required value={correoEV} onChange={(e) => setCorreoEV(e.target.value)} />
              </div>
              <div className="input-group">
                <input type="tel" placeholder="Teléfono (opcional)" value={telefonoEV} onChange={(e) => setTelefonoEV(e.target.value)} />
              </div>
              <div className="input-group">
                <textarea placeholder="Marca y modelo del auto, dirección de instalación, etc." rows="4" value={mensajeEV} onChange={(e) => setMensajeEV(e.target.value)}></textarea>
              </div>
              <button type="submit" className="btn-enviar-ev">⚡ Solicitar Presupuesto</button>
            </form>
          </div>
        </section>

        {/* SECCIÓN SERVICIOS */}
        <section id="servicios" className="servicios-section">
          <div className="seccion-header">
            <h2>Nuestra Especialidad</h2>
            <div className="linea-decorativa"></div>
          </div>
          
          <div className="grid-servicios">
            {/* Tarjeta 1 */}
            <div className="card-servicio">
              <div className="icon-container">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              </div>
              <h3>Proyectos Eléctricos</h3>
              <p>Diseño, ejecución y mantenimiento de instalaciones de alta y baja tensión, cumpliendo con los más estrictos estándares de calidad y seguridad industrial.</p>
            </div>

            {/* Tarjeta 2 */}
            <div className="card-servicio">
              <div className="icon-container">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
              </div>
              <h3>Automatización</h3>
              <p>Integramos sistemas inteligentes para el control operativo de maquinarias y edificios, buscando la máxima eficiencia energética y reducción de costos.</p>
            </div>

            {/* Tarjeta 3 */}
            <div className="card-servicio">
              <div className="icon-container">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              </div>
              <h3>Autorizada ante UTE</h3>
              <p>ASPE cuenta con la habilitación de UTE para conexiones o modificaciones de servicios de energía en baja tensión.</p>
            </div>
          </div>
        </section>

        {/* SECCIÓN FORMULARIO */}
        <section id="registro" className="contacto-section">
          <div className="contacto-container">
            <div className="contacto-info">
              <h2>Trabajemos Juntos</h2>
              <p>Complete el formulario y un especialista de ASPE se pondrá en contacto a la brevedad para brindarle asesoramiento personalizado. Atendemos en Maldonado, Punta del Este y todo Uruguay.</p>
            </div>
            
            <form className="formulario-elegante" onSubmit={enviarFormulario}>
              <div className="input-group">
                <input type="text" placeholder="Nombre completo u Organización" required value={nombre} onChange={(e) => setNombre(e.target.value)} />
              </div>
              <div className="input-group">
                <input type="email" placeholder="Correo electrónico" required value={correo} onChange={(e) => setCorreo(e.target.value)} />
              </div>
              <div className="input-group">
                <textarea placeholder="Detalle su consulta o proyecto..." rows="5" required value={mensaje} onChange={(e) => setMensaje(e.target.value)}></textarea>
              </div>
              <button type="submit" className="btn-enviar">Solicitar Asesoramiento</button>
            </form>
          </div>
        </section>
      </main>

      {/* --- PIE DE PÁGINA --- */}
      <footer className="footer-elegante">
        <div className="footer-content">
          <img src="/logo.png" alt="ASPE Logo" className="footer-logo" />
          <p className="footer-zona">Electricista habilitado ante UTE — Maldonado, Punta del Este y todo Uruguay.</p>
          <p>© {new Date().getFullYear()} Acosta Silva Proeléctrica. Todos los derechos reservados.</p>
        </div>
      </footer>

      {/* BOTÓN WHATSAPP */}
      <a href="https://wa.me/59898896811" className="whatsapp-flotante" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp">
        <svg viewBox="0 0 24 24" fill="white" width="30" height="30">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.015c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
            </svg>
          </a>
        </div>
      );
    }

    export default App;